import Skeleton from "Components/Common/Skeleton/Skeleton";

export default function ProgressSectionSkeleton() {
  return (
    <div>
      {/* Tabs */}
      <div className="report-tabs" style={{ gap: 8, display: "flex", marginBottom: 20 }}>
        {[120, 140, 130, 120].map((w, i) => (
          <Skeleton key={i} width={w} height={34} borderRadius={6} />
        ))}
      </div>

      {/* Phase Completion card */}
      <div className="card" style={{ marginBottom: 16 }}>
        <Skeleton width={160} height={16} style={{ marginBottom: 20 }} />
        {[1, 2, 3, 4, 5].map((i) => (
          <div className="phase-block" key={i} style={{ marginBottom: 18 }}>
            <div className="phase-header" style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
              <Skeleton width={180} height={13} />
              <Skeleton width={36} height={13} />
            </div>
            <Skeleton height={8} borderRadius={4} style={{ width: "100%", marginBottom: 8 }} />
            <Skeleton width={220} height={11} style={{ marginBottom: 4 }} />
            <Skeleton width={180} height={11} />
          </div>
        ))}
      </div>

      {/* Inspector Notes card */}
      <div className="card" style={{ marginBottom: 16 }}>
        <Skeleton width={160} height={16} style={{ marginBottom: 16 }} />
        {[280, 320, 260, 300].map((w, i) => (
          <Skeleton key={i} width={w} height={12} style={{ marginBottom: 10 }} />
        ))}
      </div>

      {/* Photos card */}
      <div className="card" style={{ marginBottom: 16 }}>
        <Skeleton width={140} height={16} style={{ marginBottom: 16 }} />
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
          {[1, 2, 3].map((i) => (
            <div key={i}>
              <Skeleton height={120} borderRadius={8} style={{ width: "100%", marginBottom: 8 }} />
              <Skeleton width={100} height={11} />
            </div>
          ))}
        </div>
      </div>

      {/* Closing Notes card */}
      <div className="card">
        <Skeleton width={200} height={16} style={{ marginBottom: 20 }} />
        <div className="two-col">
          <div>
            <Skeleton width={140} height={13} style={{ marginBottom: 12 }} />
            {[260, 230, 250, 240].map((w, i) => (
              <Skeleton key={i} width={w} height={11} style={{ marginBottom: 8 }} />
            ))}
          </div>
          <div>
            <Skeleton width={160} height={13} style={{ marginBottom: 12 }} />
            {[220, 200, 190].map((w, i) => (
              <Skeleton key={i} width={w} height={11} style={{ marginBottom: 8 }} />
            ))}
            <Skeleton width="100%" height={40} borderRadius={6} style={{ marginTop: 12 }} />
          </div>
        </div>
        <Skeleton width={340} height={11} style={{ marginTop: 16 }} />
      </div>
    </div>
  );
}
